import * as React from "react";

export const IconConstruction = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.9041 13.0504L13.7828 15.1717L19.779 21.1679L21.9003 19.0466L15.9041 13.0504Z" fill="white" />
    <path
      d="M17.5001 9.9998C19.4301 9.9998 21.0001 8.4298 21.0001 6.4998C21.0001 5.9198 20.8401 5.3798 20.5901 4.8998L17.8901 7.5998L16.4001 6.1098L19.1001 3.4098C18.6201 3.1598 18.0801 2.9998 17.5001 2.9998C15.5701 2.9998 14.0001 4.5698 14.0001 6.4998C14.0001 6.9098 14.0801 7.2998 14.2101 7.6598L12.3601 9.5098L10.5801 7.7298L11.2901 7.0198L9.8801 5.6098L12.0001 3.4898C10.8301 2.3198 8.9301 2.3198 7.7601 3.4898L4.2201 7.0298L5.6301 8.4398H2.8101L2.1001 9.1498L5.6401 12.6898L6.3501 11.9798V9.1498L7.7601 10.5598L8.4701 9.8498L10.2501 11.6298L2.8401 19.0398L4.9601 21.1598L16.3401 9.7898C16.7001 9.9198 17.0901 9.9998 17.5001 9.9998Z"
      fill="white"
    />
  </svg>
);
